document.addEventListener("DOMContentLoaded", function () {
  const productJsonEl = document.getElementById("pi-product-json");
  if (!productJsonEl) return;
  const productData = JSON.parse(productJsonEl.textContent);

  const optionInputs = document.querySelectorAll(".single-option-selector__radio");

  optionInputs.forEach(input => {
    input.addEventListener("change", handleVariantChange);
  });

  function handleVariantChange() {
    console.log("handleVariantChange");

    // Collect selected values based on data-index
    const selectedOptions = [];
    ["option1", "option2", "option3"].forEach((optKey, index) => {
      const checked = document.querySelector(`input[data-index="${optKey}"]:checked`);
      if (checked) {
        selectedOptions[index] = checked.value;
        console.log(`Selected ${optKey}:`, checked.value);
      }
    });

    // Find matching variant
    const matchedVariant = productData.variants.find(v =>
      v.options.every((optVal, i) => optVal === selectedOptions[i])
    );

    console.log("Matched Variant:", matchedVariant);

    if (matchedVariant) {
      document.querySelectorAll(".pi--variant-description").forEach(desc => {
        desc.classList.add("pi--hidden");
      });

      const targetDesc = document.querySelector(`.pi--variant-description-${matchedVariant.id}`);
      console.log("Target Description:", targetDesc);

      if (targetDesc) {
        targetDesc.classList.remove("pi--hidden");
      }
    }
  }
});
